// Utility functions for accordion functionality in academic articles

export function toggleAccordion(header: Element) {
  const acc = header.closest('.accordion')
  if (acc) {
    acc.classList.toggle('open')
  }
}

export function isAccordionHeader(element: Element): boolean {
  return element.classList.contains('accordion') && element.tagName === 'H2'
}

function createChevronSvg(): SVGElement {
  const svgNS = 'http://www.w3.org/2000/svg'
  const svg = document.createElementNS(svgNS, 'svg')
  svg.setAttribute('viewBox', '0 0 24 24')
  svg.setAttribute('width', '1em')
  svg.setAttribute('height', '1em')
  svg.setAttribute('fill', 'none')
  svg.setAttribute('stroke', 'currentColor')
  svg.setAttribute('stroke-width', '2')
  svg.setAttribute('stroke-linecap', 'round')
  svg.setAttribute('stroke-linejoin', 'round')
  svg.setAttribute('aria-hidden', 'true')
  svg.setAttribute('focusable', 'false')
  svg.setAttribute('data-accordion-chevron', 'true')

  const path = document.createElementNS(svgNS, 'polyline')
  path.setAttribute('points', '6 9 12 15 18 9')
  svg.appendChild(path)
  return svg
}

/**
 * Injects a chevron icon into each accordion header (right side),
 * and rotates it when `.open` is applied on the accordion container.
 * Safe to call multiple times – avoids duplicates.
 */
export function injectChevronIntoAccordionHeaders(root: Element): void {
  const headers = root.querySelectorAll('.accordion h2')
  headers.forEach((header) => {
    const h = header as HTMLElement
    const existing = h.querySelector('[data-accordion-chevron="true"]')
    if (existing) {
      return
    }
    const svg = createChevronSvg()
    svg.style.marginLeft = '0.5rem'
    h.appendChild(svg)
  })
}
